"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _index = require("../../index");

var _SegmentList = _interopRequireDefault(require("./SegmentList"));

var _GroupedPersonaTable = _interopRequireDefault(require("./GroupedPersonaTable/GroupedPersonaTable"));

var _CampaignPersonaFilters = _interopRequireDefault(require("../containers/CampaignCreator/CampaignPersonaFilters"));

var _Sidebar = _interopRequireDefault(require("../components/CampaignCreator/Sidebar"));

var _Tabs = _interopRequireDefault(require("../components/CampaignCreator/Tabs"));

var _DataCaveats = _interopRequireDefault(require("../components/DataCaveats"));

var _DataFilterNote = _interopRequireDefault(require("../components/DataFilterNote"));

var _CampaignPersonaFilterTagList = _interopRequireDefault(require("../containers/CampaignCreator/CampaignPersonaFilterTagList"));

var _ResetButton = _interopRequireDefault(require("./ResetButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AudienceProfiling = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AudienceProfiling, _React$Component);

  function AudienceProfiling(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "switchTab", function (tabNumber) {
      _this.setState({
        activeTab: tabNumber
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearForm", function () {
      _this.props.resetDataPage();

      _this.switchTab(0);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSidebar", function () {
      _this.setState(_extends({}, _this.state, {
        showSidebar: !_this.state.showSidebar
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckBoxAction", function () {
      _this.props.loadGroupedPersona();
    });

    _this.state = {
      showSidebar: false,
      activeTab: 0,
      selectedPersonas: []
    };
    return _this;
  }

  var _proto = AudienceProfiling.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        isDataPage = _this$props.isDataPage,
        loadSuperSegments = _this$props.loadSuperSegments,
        loadGroupedPersona = _this$props.loadGroupedPersona,
        featureAccess = _this$props.featureAccess,
        loadProfileCategories = _this$props.loadProfileCategories,
        minShareOfAudience = _this$props.minShareOfAudience,
        setShareOfAudience = _this$props.setShareOfAudience,
        resetDataPage = _this$props.resetDataPage,
        quadrantPersonas = _this$props.quadrantPersonas,
        setSelectedPersonas = _this$props.setSelectedPersonas;

    if (quadrantPersonas) {
      setSelectedPersonas(quadrantPersonas);
    }

    if (isDataPage) {
      resetDataPage(); // Clear page state if it's a data page
    }

    loadSuperSegments();
    loadGroupedPersona();
    featureAccess();
    loadProfileCategories();

    if (minShareOfAudience) {
      setShareOfAudience(minShareOfAudience);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        isFetching = _this$props2.isFetching,
        superSegments = _this$props2.superSegments,
        groupedPersonaRecords = _this$props2.groupedPersonaRecords,
        themesFor = _this$props2.themesFor,
        _this$props2$isDataPa = _this$props2.isDataPage,
        isDataPage = _this$props2$isDataPa === void 0 ? false : _this$props2$isDataPa,
        hasAccess = _this$props2.hasAccess,
        theme = _this$props2.theme,
        filters = _this$props2.filters,
        tableTitle = _this$props2.tableTitle;
    var showSidebar = this.state.showSidebar;

    if (isFetching || !superSegments) {
      return /*#__PURE__*/React.createElement(_index.LoadingIndicator, null);
    }

    var PersonaFilters = function PersonaFilters(props) {
      return /*#__PURE__*/React.createElement(_CampaignPersonaFilters["default"], props);
    };

    var panes = [{
      menuItem: 'Audience',
      pane: /*#__PURE__*/React.createElement(_SegmentList["default"], {
        expanded: true,
        handleCheckBoxAction: this.handleCheckBoxAction
      })
    }, {
      menuItem: 'Attributes',
      pane: /*#__PURE__*/React.createElement(PersonaFilters, {
        theme: theme,
        filters: filters,
        themesFor: themesFor,
        groupedPersonaRecords: groupedPersonaRecords
      })
    }];

    var Title = function Title() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_semanticUiReact.Icon, {
        className: "grouped-personas__icon",
        name: "bars",
        size: "large",
        onClick: _this2.toggleSidebar
      }), /*#__PURE__*/React.createElement("h2", {
        className: "grouped-personas__sub-title"
      }, "Selection"), isDataPage && /*#__PURE__*/React.createElement(_ResetButton["default"], {
        resetMethod: _this2.clearForm
      }));
    };

    var PersonaFilterTagList = function PersonaFilterTagList(props) {
      return /*#__PURE__*/React.createElement(_CampaignPersonaFilterTagList["default"], props);
    };

    return /*#__PURE__*/React.createElement("div", null, hasAccess ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "campaign-creator-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grouped-personas__row"
    }, /*#__PURE__*/React.createElement(_Sidebar["default"], {
      open: showSidebar,
      title: /*#__PURE__*/React.createElement(Title, null),
      body: /*#__PURE__*/React.createElement(_Tabs["default"], {
        className: "tabs grouped-personas__tabs",
        panes: panes,
        switchTab: this.switchTab,
        activeTab: this.state.activeTab
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "grouped-personas__table audience-profiling--table-row__fixed-height"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "audience-profiling__title"
    }, tableTitle), /*#__PURE__*/React.createElement(PersonaFilterTagList, {
      theme: theme,
      filters: filters,
      themesFor: themesFor,
      isDataPage: isDataPage
    }), /*#__PURE__*/React.createElement(_GroupedPersonaTable["default"], {
      groupedPersonaRecords: groupedPersonaRecords,
      filters: filters,
      theme: theme,
      isFetching: this.props.isFetchingGroupedPersona
    }), groupedPersonaRecords && Object.keys(groupedPersonaRecords).length > 0 && /*#__PURE__*/React.createElement(_DataFilterNote["default"], {
      filters: filters,
      theme: theme
    }))), /*#__PURE__*/React.createElement("div", {
      className: "grouped-personas__row"
    }, /*#__PURE__*/React.createElement(_DataCaveats["default"], {
      showDownload: false
    })))) : '');
  };

  return AudienceProfiling;
}(React.Component);

exports["default"] = AudienceProfiling;